<form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
  <div class="form-group row deliveryNote">
    <div class="col-sm-2 mt-1 pr-1">
      <label class="form-control-static" i18n="@@CreateDeliveryNoteNameLabel">Name der CSV-Datei:</label>
    </div>
    <div class="col-sm-10">
      <div class="d-flex">
        <input type="text" class="form-control" id="deliveryNoteNumber" formControlName="deliveryNoteNumber"
          i18n-placeholder="@@NameOfDeleveryNotePlaceholder" placeholder="Name der CSV-Datei" />
        <button type="submit" id="create_deliverycsv_inline" class="btn btn-save ms-2" style="min-width: 100px;"
          [disabled]="!formService.form.valid" i18n="@@CreateDeliveryCSVButton">Speichern</button>
      </div>

      <div class="error">
        <em
          *ngIf="formService.validateControl('deliveryNoteNumber') && formService.hasError('deliveryNoteNumber', 'required')"
          i18n="@@DeliveryNoteNumberRequiredError">Name wird benötigt</em>
      </div>
    </div>
  </div>
</form>

<div *ngIf="tableReady">
  <app-table [table]="table"></app-table>
</div>

<div *ngIf="!tableReady" class="loading-spinner-container">
  <div class="spinner-border text-primary loading-spinner-md" role="status">
    <span class="visually-hidden-focusable" i18n="@@Loading">Loading...</span>
  </div>
</div>